import React from 'react';
import { AlertTriangle } from 'lucide-react';

const CrisisTicker = () => {
  const alertText = "URGENT: California Defunding Rehabilitation Programs • Thousands Left Without Support • Your Donation Makes The Difference";
  
  return (
    <div className="bg-[#C84B31] border-y-2 border-[#E63946] py-3 overflow-hidden">
      <div className="flex items-center animate-scroll">
        {['a', 'b', 'c'].map((copy) => (
          <div key={`ticker-${copy}`} className="flex items-center whitespace-nowrap px-8">
            <AlertTriangle className="w-5 h-5 text-white mr-3 flex-shrink-0 animate-pulse" />
            <span className="text-white font-bold text-lg" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              {alertText}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CrisisTicker;
